export default __webpack_public_path__ + "static/media/kitchen3-afterC-480w.29e0bb10.avif";